import React, { useState } from 'react';
import { KatAlert } from '@amzn/katal-react';

/**
 * Dismissible info banner shown once after the DUB (EU) -> ZAZ Midway-door
 * redirect, so operators understand why the URL changed under them.
 *
 * Rendered only when {@link show} is true — i.e. when the page load consumed
 * the `redirectedFrom=dub` marker appended by `runRegionRedirect` (see
 * `consumeRedirectMarker` in `src/utils/RegionRedirect.ts`). The marker is
 * stripped from the URL before React mounts, so refreshes, bookmarks, and
 * shared links never re-show the banner.
 */
export interface RegionRedirectBannerProps
{
    /** Whether the operator landed on this page via the DUB -> ZAZ redirect. */
    show: boolean;
}

const RegionRedirectBanner = ( { show }: RegionRedirectBannerProps ): JSX.Element | null =>
{
    const [ dismissed, setDismissed ] = useState( false );

    if ( !show || dismissed ) return null;

    return (
        <KatAlert
            variant="info"
            header="You have been redirected"
            onDismiss={() => setDismissed( true )}
        >
            Newton for the EU region has moved from DUB (prod.eu.newton.aft.amazon.dev)
            to ZAZ — you are now on prod.zaz.newton.aft.amazon.dev. Your page and
            filters were preserved. Please update any bookmarks to use this URL.
        </KatAlert>
    );
};

export default RegionRedirectBanner;
